import { Component, OnInit } from '@angular/core';
import { AuthService } from '../shared/services/auth.service';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { SecurityService } from '../security.service';

@Component({
  selector: 'app-warm-up',
  templateUrl: './warm-up.component.html',
  styleUrls: ['./warm-up.component.scss']
})
export class WarmUpComponent implements OnInit {

  private betaEmail: string = '';
  private betaKey: string = '';
  private validBetaKey: boolean = false;
  private attemptedKey: boolean = false;

  constructor(private securityService: SecurityService, private router: Router, private authService: AuthService) { }

  checkKey = () => {
    if (this.betaKey.length < 13 || !this.betaEmail) return;
    this.securityService.checkBetaKey(this.betaKey, this.betaEmail).then((result: boolean) => {
      if (result) {
        this.validBetaKey = true;
      } else {
        this.attemptedKey = true;
      }
    });
  }

  ngOnInit() {
  }

  confirmRegistration(email: string, password: string) {
    if (!this.betaKey || !this.validBetaKey) {
      return alert('Close but no cigar');
    };

    Swal.fire({
      title: 'Is this correct?',
      text: `Clicking register will consume the invite for ${email}`,
      icon: 'success',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: `Yes, let's get started!`
    }).then((result) => {
      if (result.value) {
        this.authService.SignUp(email, password, this.betaKey, false).then((success) => {
          console.log(`Signup complete for ${email} : ${success} : ${this.betaKey}`);
          Swal.fire(
            'Welcome to Cloakn!',
            `You have successfully registered for our private beta! Let's create your cloaked website and get your campaigns started!`,
            'success'
          ).then(() => {
            // this.router.navigateByUrl("/user_setup");
          }).finally(() => {
            this.router.navigateByUrl("/user_setup");
          });
        });
      }
    }).finally(() => {
      console.log('finished signup, dear god, redirect me');
      
    });
  }
}
